import React from 'react'
import Lottie from "lottie-react";
import data from "./../lottie/skills.json";
import skills2 from "./../lottie/skills2.json";


const Skills = () => {
  return (
    <div className='flex flex-col h-auto ml-4 mr-4 p-20 '>
    <div class="h-16 animate-pulse w-64 text-left font-bold tracking-widest text-transparent text-3xl bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 ">Relevant Skills </div>

    <div className=' flex md:flex-row lg:flex-row flex-col'>
    <div className=' w-full'>
    <div className="container mx-auto p-4">
      <ul className="list-disc list-inside text-slate-400 tracking-wider font-mono">
      <li>DSA (Java)</li>
        <li>MERN Stack, Javascript</li>
        <li>React Native, Firebase</li>
        <li>HTML5, CSS, Tailwind CSS</li>
        <li>SQL, MongoDB</li>
        <li>Rest API, GraphCMS</li>
        <li>Cognitive Thinking</li>
        <li>Clarity of Vision</li>
        <li>Positive Attitude</li>
        <li>Time Management</li>
        <li>Good Decision Making</li>
        <li>Adaptability</li>
        

      </ul>
      <Lottie className='h-96' animationData={skills2}/>

    </div>
    </div>
    <div className=' w-full'>

      <Lottie className='h-4/5' animationData={data}/></div>
    </div>

    </div>
  )
}

export default Skills
